export interface KnowledgeSourceDTO {
  id: string;
  name: string;
  kind: string;
  status: string;
  documentCount: number;
  failedCount: number;
  lastSucceededAt?: string;
  updatedAt: string;
}

export interface KnowledgeDocumentDTO {
  id: string;
  title: string;
  url?: string;
  sourceType: string;
  status: string;
  versionCount: number;
  currentVersion?: number;
  updatedAt: string;
  lastSeenAt?: string;
  readOnly: boolean;
  legacy: boolean;
}

export interface KnowledgeVersionDTO {
  id: number;
  version: number;
  status: string;
  changeKind: string;
  sizeBytes: number;
  sourceUpdatedAt?: string;
  publishedAt?: string;
  createdAt: string;
}

export interface KnowledgeDocumentDetailDTO extends KnowledgeDocumentDTO {
  preview?: string;
  summary?: string;
  versions: KnowledgeVersionDTO[];
}

export interface KnowledgeFindingDTO {
  id: number;
  code: string;
  severity: "info" | "warning" | "error";
  summary: string;
  documentId?: number;
  sourceId?: number;
  evidence?: Record<string, unknown>;
  detectedAt: string;
}

export interface KnowledgeWorkspaceDTO {
  mode: "native" | "legacy_compatible";
  sources: KnowledgeSourceDTO[];
  documents: KnowledgeDocumentDTO[];
  quality: { status: string; errors: number; warnings: number; findings: KnowledgeFindingDTO[] };
}

const sourceLabels: Record<string, string> = {
  website: "网站抓取", sitemap: "Sitemap", url_batch: "链接列表", manual: "手动内容", file: "文件", cms: "CMS", api: "API",
};

const statusLabels: Record<string, string> = {
  idle: "等待同步", syncing: "同步中", ready: "可用", degraded: "部分失败", failed: "失败", paused: "已暂停",
  pending: "处理中", excluded: "已排除", conflict: "内容冲突", published: "已发布", disabled: "已停用",
};

const findingCopy: Record<string, { title: string; action: string }> = {
  empty_body: { title: "正文为空", action: "检查页面是否需要登录，修复后重新同步来源。" },
  duplicate: { title: "重复内容", action: "保留一个规范链接，并排除重复页面。" },
  identity_conflict: { title: "页面身份冲突", action: "检查规范链接与内容系统 ID 是否指向同一页面。" },
  stale: { title: "内容可能过期", action: "重新同步来源，并检查定时同步是否被暂停。" },
  content_gap: { title: "内容缺口", action: "检查来源同步失败数和最近一次同步结果。" },
};

export const knowledgeSourceLabel = (kind: string) => sourceLabels[kind] || kind || "未知来源";
export const knowledgeStatusLabel = (status: string) => statusLabels[status] || status || "未知";
export const knowledgeFindingCopy = (code: string) => findingCopy[code] || { title: "知识质量提醒", action: "查看关联来源或文档并重新同步。" };
export const formatBytes = (bytes: number) => bytes < 1024 ? `${bytes} B` : bytes < 1024 * 1024 ? `${Math.round(bytes / 1024)} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`;
